import type { SanityClient } from '@sanity/client';
import type { ImageUrlBuilder } from '@sanity/image-url/lib/types/builder';

import imageUrlBuilder from '@sanity/image-url';
import { client as baseClient } from '$lib/client';
import { FileUrlBuilder } from '../sanity/FileUrlBuilder';

export const key = Symbol();

export interface SanityContext {
  client: SanityClient;
  urlBuilder: ImageUrlBuilder;
  fileUrlBuilder: FileUrlBuilder;
}

export const newSanityContext = (): SanityContext => {
  const client = baseClient.withConfig({
    useCdn: true,
    apiVersion: '2023-06-29'
  });

  const { projectId, dataset } = client.config();
  if (!projectId || !dataset) {
    throw new Error('Missing projectId or dataset');
  }

  const urlBuilder = imageUrlBuilder(client);
  const fileUrlBuilder = new FileUrlBuilder(projectId, dataset);

  return {
    client,
    urlBuilder,
    fileUrlBuilder
  };
};
